module.exports = __webpack_public_path__ + "img/dagon.4fceac0f.png";